// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"06e20e02","977":"16159dbf"}[chunkId] + ".chunk.js";
};